export default "__VITE_ASSET__DfLvZUEO__"